import React from "react";
import Grid from "@material-ui/core/Grid";
import {Button} from "primereact/button";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import Paper from "@material-ui/core/Paper";
import {InputText} from "primereact/inputtext";
import LinearProgress from "@material-ui/core/LinearProgress";
import UploadFilePresval from "../../components/uploadFile/uploadFileSingle";
import {numberWithCommaDataTableTemplate, priceDataTableTemplate} from "../../utils/formatters/Numbers";
import HeaderScreenPresval from "../../components/headerScreenPresval";
import SubtitleLabel from "../../app/Title/SubtitleLabel/SubtitleLabelView";

const AvailableLendView = (props) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        {props.messagesGrowl}
                        <HeaderScreenPresval headerTitle="Prestamista \ Disponible a Prestar"
                                             onExpand={props.clearFilters}
                                             actionSearch={props.searchEmisora}>
                            <div className="p-grid">
                                <div className="p-col-12 p-md-6 p-col-6">
                                    <SubtitleLabel header="Emisora" isBold={true}/>
                                    <InputText id="emisoraToSearch"
                                               maxLength={20}
                                               placeholder={"Ex: BONOS 234543"}
                                               onChange={props.onChangeTextFilter}
                                               value={props.emisoraToSearch}/>
                                </div>
                                <div className="p-col-12 p-md-6 p-col-6">
                                    <br/>
                                    <Button label="Limpiar"
                                            style={{'float': 'right'}}
                                            onClick={props.clearFilters}
                                            className="p-button-secondary"/>
                                </div>
                            </div>
                        </HeaderScreenPresval>
                    </Grid>

                    <Grid item xs={12}>
                        <div style={{'float': 'right'}}>
                            <UploadFilePresval type={["text/csv", "application/vnd.ms-excel"]}
                                               size="1000"
                                               urlAction="/appapv/uploadFileAvailableLendClient.action"
                                               className="p-button-secondary"
                                               titleHeader="Cargar archivo"
                                               titleButton="Cargar disponibilidad"
                                               errorTypeMessage="El documento debe ser csv."
                                               errorSizeMessage="El archivo es muy pesado."
                                               instructions="Debe ser un archivo de texto con comas de separación entre los datos."
                                               action={props.searchAll}/>
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        <DataTable
                            responsive={true}
                            value={props.dataAvailableLend}
                            selectionMode="single"
                            resizableColumns={true}
                            columnResizeMode={"fit"}>
                            <Column field="emision" header="Emisora" style={{textAlign: 'left'}} sortable={true}/>
                            <Column field="cantidadDisponible" header="Títulos" style={{textAlign: 'right'}}
                                    body={numberWithCommaDataTableTemplate} sortable={true}/>
                            <Column field="precio24Hrs" header="Precio" style={{textAlign: 'right'}}
                                    body={priceDataTableTemplate} sortable={true}/>
                            <Column field="importeDisponible" header="Importe" style={{textAlign: 'right'}}
                                    body={numberWithCommaDataTableTemplate} sortable={true}/>
                        </DataTable>
                    </Grid>
                </Grid>
            </Paper>
        </React.Fragment>
    )
};

export default AvailableLendView;